export default __webpack_public_path__ + "static/media/field-arrow.ef09ea92.svg";